import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import UpsellModal from 'common/components/Upsells/UpsellModal';

import { closeFreemiumSelectedModal } from '../../actions';
import { getFreemiumSelectedModal } from '../../selectors';
import { MODAL_LIBRARY, MODAL_LOGIC, MODAL_STYLES } from '../../constants/modals';

// Form Logic
const LOGIC_HEADER_TEXT = 'Keep it personal with smart forms';
const LOGIC_CONTENT_TEXT = `Customize a guest's registration process with an easy-to-build smart
    form that will show or hide questions depending on answers.`;
const LOGIC_PICTURE_URL = 'https://d24wuq6o951i2g.cloudfront.net/img/site-assets/conditional_logic_upsell.png'; // eslint-disable-line max-len
const LOGIC_REDIRECT_URL = 'https://bit.ly/splash-forms-logic';
const LOGIC_PICTURE_ALT = 'An illustrated person picking questions from a data tree of options';

// Question Library
const LIBRARY_HEADER_TEXT = 'Build forms faster';
const LIBRARY_CONTENT_TEXT = 'Quickly add questions from previous events using your Question Bank';
const LIBRARY_PICTURE_URL = 'https://d24wuq6o951i2g.cloudfront.net/img/site-assets/question_bank_upsell.png'; // eslint-disable-line max-len
const LIBRARY_REDIRECT_URL = 'https://bit.ly/splash-forms-library';
const LIBRARY_PICTURE_ALT = 'An illustrated piggy bank covered in question marks next to a bottle of glue'; // eslint-disable-line max-len

// Styling Forms
const STYLES_HEADER_TEXT = 'Your brand. Your form';
const STYLES_CONTENT_TEXT = `Keep your form consistent with the rest of your event's
    touchpoints with custom form styling`;
const STYLES_PICTURE_URL = 'https://d24wuq6o951i2g.cloudfront.net/img/site-assets/form_styling_upsell.png'; // eslint-disable-line max-len
const STYLES_REDIRECT_URL = 'https://bit.ly/splash-forms-styling';
const STYLES_PICTURE_ALT = 'Illustrated people painting a form';

const DEFAULT_BUTTON_LABEL = 'Check out all we have to offer';

const SELECTED_MODAL_PROPS = {
    [MODAL_LOGIC]: {
        headline: LOGIC_HEADER_TEXT,
        text: LOGIC_CONTENT_TEXT,
        illustrationSource: LOGIC_PICTURE_URL,
        illustrationDescription: LOGIC_PICTURE_ALT,
        buttonLink: LOGIC_REDIRECT_URL,
        buttonLabel: DEFAULT_BUTTON_LABEL,
    },
    [MODAL_LIBRARY]: {
        headline: LIBRARY_HEADER_TEXT,
        text: LIBRARY_CONTENT_TEXT,
        illustrationSource: LIBRARY_PICTURE_URL,
        illustrationDescription: LIBRARY_PICTURE_ALT,
        buttonLink: LIBRARY_REDIRECT_URL,
        buttonLabel: DEFAULT_BUTTON_LABEL,
    },
    [MODAL_STYLES]: {
        headline: STYLES_HEADER_TEXT,
        text: STYLES_CONTENT_TEXT,
        illustrationSource: STYLES_PICTURE_URL,
        illustrationDescription: STYLES_PICTURE_ALT,
        buttonLink: STYLES_REDIRECT_URL,
        buttonLabel: DEFAULT_BUTTON_LABEL,
    },
};

const FreemiumModals = ({ selected, onRequestClose }) =>
    SELECTED_MODAL_PROPS[selected] ? (
        <UpsellModal onRequestClose={onRequestClose} {...SELECTED_MODAL_PROPS[selected]} />
    ) : null;

FreemiumModals.propTypes = {
    selected: PropTypes.string.isRequired,
    onRequestClose: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
    selected: getFreemiumSelectedModal(state),
});

const mapDispatchToProps = {
    onRequestClose: closeFreemiumSelectedModal,
};

export default connect(mapStateToProps, mapDispatchToProps)(FreemiumModals);
